import { useEffect, useState } from "react";
import "./SensorAnalysisReportComponent.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { WhiteCrossIcon, SensorsIcon, CopyIcon, TrashIcon } from "../../SatelliteProfileImgAssets/SatelliteProfileImgAssets";
import { panelPublicUrl } from "../../../../../../panelurl";
import MissionService from "../../../../../../service/MissionService";
import { useParams } from "react-router-dom";
import { showToastMessage } from "../../../../../../utils/commonFunctions";
import ModalDropdown from "../../../../../CommonComponents/ModalDropdown";
import ConfirmationDialog from "../../../../../CommonComponents/confirmation_dialog/ConfirmationDialog";
import CustomToolTip from "../../../../../CommonComponents/CustomToolTip";

const SensorAnalysisReportComponent = ({ reportProps, isReportBarOpen, newSensorAnalysis, setNewSensorAnalysis }) => {
  const params = useParams();
  const { sat_id } = params;

  const [allReports, setAllReports] = useState<any>()
  const [activeReports, setActiveReports] = useState<number[]>([]);
  const [showReportDetail, setShowReportDetail] = useState(false);
  const [options, setOptions] = useState<any>()
  const [openDeleteDialouge, setOpenDeleteDialouge] = useState(false)
  const [currentReport, setCurrentReport] = useState({})

  const toggleActiveReport = (index: number) => {
    setActiveReports((prevActiveReports) => {
      if (prevActiveReports.includes(index) && showReportDetail) {
        {/** Close report */ }
        setShowReportDetail(false)
        return prevActiveReports.filter((id) => id !== index);
      } else {
        {/** Open report */ }
        setShowReportDetail(true)
        return [...prevActiveReports, index];
      }
    });
  };

  const getAllReports = () => {
    MissionService.getAllReports(sat_id)?.then((res) => {
      if (res) {
        setAllReports(res?.data);
        // by default open the latest report 
        if (res?.data && res?.data?.length > 0) {
          setActiveReports([res?.data?.length - 1])
        }
      }
    }).catch((error) => {
      const message = "An error occurred while fetching reports. Please try again."
      showToastMessage('error', message)
    })
  }


  useEffect(() => {
    getAllReports()
  }, [isReportBarOpen, newSensorAnalysis])


  useEffect(() => {
    if (allReports) {
      let finalBody: any = []
      allReports?.map((singleReport) => {
        let allControlMode: any = []
        let allEntities: any = [{ label: 'Sun', values: 'Sun' }, { label: 'Earth', values: 'Earth' }]
        let sunEntity = [{ label: 'Sun', values: 'Sun' }]
        let allSensors: any = []
        let selectedControlMode: any
        let selectedEntity: any
        let selectedSensor: any

        singleReport?.grafanaPanelUrls?.map((panel, index) => {
          if (index === 0) {
            selectedControlMode = panel?.controlModeName
            selectedEntity = 'Sun'
            let allSensorss: any = []
            panel?.sunEntityPanelUrls?.map((sunEntity, key) => {
              allSensorss.push({ label: sunEntity?.panelNameSensorName, value: sunEntity })
            })
            allSensors = allSensorss
            selectedSensor = allSensorss?.[0]?.value
          }
          allControlMode.push({ label: panel?.controlModeName, value: panel?.controlModeName })
        })

        finalBody.push({
          reportName: singleReport.name,
          allControlMode: allControlMode,
          allEntities: singleReport?.sensorsConfigurations?.[0]?.sensorType === "payload" ? sunEntity : allEntities,
          allSensors: allSensors,
          selectedControlMode: selectedControlMode,
          selectedEntity: selectedEntity,
          selectedSensor: selectedSensor
        })

      })
      setOptions(finalBody)
      setNewSensorAnalysis(false)
    }
  }, [allReports, newSensorAnalysis])

  const deleteReport = (report) => {
    MissionService.deleteReoprt(report?.reportName, sat_id).then((res) => {
      if (res) {
        getAllReports()
        showToastMessage('success', 'Report deleted successfully')
      }
    }).catch((err) => {
      console.log(err)
      showToastMessage('error', 'Report not deleted')
    })
  }

  const handleControlModeChanges = (reports, e) => {
    let sensorPanelUrl: any = []
    allReports?.map((report, index) => {
      if (report?.name === reports?.reportName) {
        report?.grafanaPanelUrls?.map((panel, key) => {
          if (panel?.controlModeName === e.label) {
            sensorPanelUrl = setEntityPanel(panel?.sunEntityPanelUrls)
          }
        })
      }
    })

    let selectedControlMode = options?.map((option) => {
      if (option.reportName === reports.reportName) {
        return {
          ...option,
          selectedSensor: sensorPanelUrl?.[0]?.value,
          allSensors: sensorPanelUrl,
          selectedEntity: 'Sun'
        };
      }
      return option;
    })

    setOptions(selectedControlMode)
  }

  const handleSelectedSensor = (report, e) => {
    let selectedPanelList = options?.map((option) => {
      if (option.reportName === report.reportName) {
        return {
          ...option,
          selectedSensor: e.value
        };
      }
      return option;
    })
    setOptions(selectedPanelList)
  }

  const setEntityPanel = (urls) => {
    let selectedUrl: any = []
    urls?.map((url, index) => {
      selectedUrl.push({ label: url?.panelNameSensorName, value: url })
    })
    return selectedUrl
  }

  const handleSelectedEntity = (report, e) => {
    let entityList: any = []
    allReports?.map((reports) => {
      if (report?.reportName === reports.name) {
        reports?.grafanaPanelUrls?.map((grafana, key) => {
          if (e.label === 'Sun') {
            entityList = setEntityPanel(grafana?.sunEntityPanelUrls)
          } else {
            entityList = setEntityPanel(grafana?.earthEntityPanelUrls)
          }
        })
      }
    })

    let selectedPanelList = options?.map((option) => {
      if (option.reportName === report.reportName) {
        return {
          ...option,
          allSensors: entityList,
          selectedSensor: entityList?.[0]?.value
        };
      }
      return option;
    })
    setOptions(selectedPanelList)
  }

  const confirmDeleteReport = () => {
    if (currentReport) {
      deleteReport(currentReport);
      setShowReportDetail(false); // hiding the detail modal
    }
  }

  return (
    <>
      <div className="SensorAnalysisReportComponent">
        {/* Header section */}

        <div className="customModelReportHeader">
          <div className="customModelReportHeaderTitle">Reports</div>
          <button className="" onClick={() => { reportProps.setIsReportBarOpen(false) }}>
            <WhiteCrossIcon />
          </button>
        </div>

        {/* Report Items */}
        {allReports && options &&
          options.map((report, index) => (
            <>
              {/* Report Header */}
              <div
                key={index}
                className={activeReports.includes(index) ? "individualReportHeader active" : "individualReportHeader"}
              >
                <div className="individualReportHeaderItem" onClick={() => {
                  toggleActiveReport(index)
                }}>
                  <div className="reportTitle">{report?.reportName}</div>
                  {/* <div className="reportDate">{report.date}</div> */}
                </div>
                {/* delete report */}
                <CustomToolTip title={"Delete"} placement="top">
                  {activeReports.includes(index) && (
                    <div className="infoCardReportTrashIconDiv" onClick={() => {
                      setCurrentReport(report)
                      setOpenDeleteDialouge(true)
                      setActiveReports((prev) => prev.filter((i) => i !== index)); // remove the report from active
                    }}>
                      <TrashIcon />
                    </div>
                  )}
                </CustomToolTip>
              </div >
              {/* End of Report Header */}

              {
                activeReports.includes(index) && (
                  <div className="individualReportBody">
                    {/* Inputs box of report */}
                    <div className="individualReportBodyItem">
                      <div className="">Inputs</div>
                      <div className="individualReportBodyInputBox">
                        <div><SensorsIcon /></div>
                        <div>{report?.allSensors?.length === 1 ? report?.allSensors?.length : (report?.allSensors?.length - 1)}</div>
                      </div>
                    </div>
                    {/* Outputs box of report */}
                    <div className="individualReportBodyItem">
                      <div className="">Output</div>
                      {/* Dropdown for All Control modes */}
                      {options &&
                        (report?.allControlMode?.length > 1) ? (
                        <ModalDropdown
                          options={report?.allControlMode}
                          isMulti={false}
                          handleSelectedOption={(e) => {
                            handleControlModeChanges(report, e)
                          }}
                          previousOption={report?.allControlMode?.[0]?.label}
                          isSensorAnalysisReport={true}
                        />
                      ) : (
                        <span className="individualReportBodyItem dropdownText"> {report?.allControlMode?.[0]?.label || ""} </span>
                      )
                      }
                    </div>
                    <div className="individualReportBodyItem">
                      {/* DropDown for All Sensors */}
                      {options &&
                        (report?.allSensors?.length > 1) ? (
                        <ModalDropdown
                          options={report?.allSensors}
                          isMulti={false}
                          handleSelectedOption={(e) => {
                            handleSelectedSensor(report, e)
                          }}
                          previousOption={report?.selectedSensor?.panelNameSensorName}
                          isSensorAnalysisReport={true}
                        />
                      ) : (
                        <span className="individualReportBodyItem dropdownText"> {report?.selectedSensor?.panelNameSensorName || ""} </span>
                      )
                      }
                      <div className="reportBodyItemText">
                        {/* DropDown for all Entities */}
                        {options &&
                          (report?.allEntities?.length > 1) ? (
                          <ModalDropdown
                            options={report?.allEntities}
                            isMulti={false}
                            handleSelectedOption={(e) => {
                              handleSelectedEntity(report, e)
                            }
                            }
                            previousOption={report?.allEntities?.[0]?.label}
                            isSensorAnalysisReport={true}
                          />
                        ) : (
                          <span className="individualReportBodyItem dropdownText"> {report?.allEntities?.[0]?.label || ""} </span>
                        )
                        }
                      </div>
                    </div>
                    <div style={{ width: '100%', height: '400px' }}>
                      <iframe src={`${panelPublicUrl}${report?.selectedSensor?.panelUrl}`} className='panel__frame__control__mode' />
                    </div>
                  </div>
                )
              }
            </>
          ))}
      </div >
      <ConfirmationDialog
        type='delete'
        open={openDeleteDialouge ? true : false}
        title={`Delete Report?`}
        description={`Deleting this Report will permanently erase all associated data and historical records.`}
        onCancel={() => setOpenDeleteDialouge(false)}
        onConfirm={() => {
          confirmDeleteReport();
          setOpenDeleteDialouge(false)
        }}
        confirm_button_text={`Delete`}
      />
    </>
  );
};

export default SensorAnalysisReportComponent;
